import { FC, PropsWithChildren, useEffect, useState } from 'react';

import { Theme, THEME_STORAGE_KEY } from '@/shared/config';
import { ThemeContext } from '@/shared/contexts';
import { themeInstall } from '@/shared/libs';

export const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>(themeInstall());

  const changeTheme = (val: Theme) => {
    setTheme(val);
    document.documentElement.classList.toggle('dark', val === Theme.Dark);
    localStorage.setItem(THEME_STORAGE_KEY, val);
  };

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === Theme.Dark);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ changeTheme, theme }}>
      {children}
    </ThemeContext.Provider>
  );
};
